import { FoldedCornerPlugin } from "../FoldedCornerPlugin";

export class ExposeApiPlugin extends FoldedCornerPlugin {
    name = "Expose API";

    constructor(options, ctx, data) {
        const colors = {
            fill: "#444444", fillFirstTriangle: "#fdf8fa", fillSecondTriangle: "#4BCFFF", stroke: "#FFFFFF"
        };
        super(options, ctx, colors, data);
        this.points = { start: 20, end: 20, initial: 4 };
    }

    draw() {
        super.drawFolded();
    }

    update(options) {
        super.updateFoldedPlugin(options);
    }
}
